/**
 * Audit Clauses Data Hook
 *
 * Fetches standard clause data for an audit from the backend
 * and returns it as a StandardClauseSet.
 */

import { api } from "convex/_generated/api";
import type { AuditId, StandardClauseSet } from "@/packages/types";
import { useWorkspaceQuery } from "@/hooks";

/* ------------------------------------------------------------------ */
/* useAuditClauses                                                     */
/* ------------------------------------------------------------------ */

interface UseAuditClausesReturn {
  clauseSet: StandardClauseSet | null;
  isLoading: boolean;
}

export function useAuditClauses(
  auditId: AuditId | null,
): UseAuditClausesReturn {
  const { data, isLoading } = useWorkspaceQuery(
    api.audit_queries.getStandardClausesForAudit,
    { auditId: auditId ?? null },
  );

  return {
    clauseSet: (data as StandardClauseSet | undefined) ?? null,
    isLoading,
  };
}
